var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 125.742,
    viewBox: "0 0 105 125.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-790 -858)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(790.215 858)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M815.8,917.015c10.816,0,17.262,8.243,17.262,18.439,0,10.3-5.9,19.3-17.151,19.3-10.926,0-16.825-9.436-16.825-19.413,0-9.544,6.556-18.331,16.715-18.331m16.825,44.361h8.741V858h-8.741v59.665H832.4a22.261,22.261,0,0,0-17.59-8.676c-15.4,0-24.691,12.473-24.691,27.007,0,14.1,9.506,26.79,24.583,26.79a21.947,21.947,0,0,0,17.7-8.46h.218Z",
    transform: "translate(-790.123 -858)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M831.462,914.185h7.976c10.051,0,22.288,1.843,22.288,14.532,0,12.473-10.816,14.969-21.086,14.969h-9.177v-29.5m-9.176,37.96H841.4c16.279,0,29.5-6.507,29.5-22.777,0-9.763-5.789-18.547-15.622-20.933,5.573-3.688,8.084-9.328,8.084-15.945,0-16.7-12.564-22.125-27.531-22.125H822.286Zm9.176-73.32h3.606c11.252,0,19.118,1.3,19.118,13.666,0,12.69-8.849,13.882-19.228,13.882h-3.5Z",
    transform: "translate(-766.116 -848.77)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(797.146 970.316)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M796.408,924.41h.545a2.5,2.5,0,1,1-.024,4.991h-.52V924.41m-2.316,6.954h3.285a4.459,4.459,0,1,0,0-8.917h-3.285Z",
    transform: "translate(-794.092 -922.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M805.391,924.41v1.49H808v1.963h-2.612V929.4h2.754v1.963h-5.071v-8.917h5.071v1.963Z",
    transform: "translate(-787.387 -922.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M817.632,925.541a2.513,2.513,0,0,0-2.033-.981,2.346,2.346,0,0,0-2.375,2.471,2.311,2.311,0,0,0,2.41,2.422,2.661,2.661,0,0,0,2-.945v2.779a6.525,6.525,0,0,1-2.045.414,4.958,4.958,0,0,1-3.344-1.311,4.36,4.36,0,0,1-1.43-3.37,4.668,4.668,0,0,1,1.312-3.264,4.833,4.833,0,0,1,3.392-1.443,5.391,5.391,0,0,1,2.116.451v2.778",
    transform: "translate(-781.612 -922.312)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.317,
    height: 8.917,
    transform: "translate(45.347 0.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M828.978,927.674h.237c.756,0,1.9-.107,1.9.969,0,.982-1.158.948-1.842.948h-.3v-1.918m1.254,3.69c1.631,0,3.226-.615,3.226-2.483a2.006,2.006,0,0,0-1.82-2.272v-.023a1.852,1.852,0,0,0,.981-1.822c0-1.7-1.064-2.317-2.647-2.317h-3.31v8.917Zm-1.254-7.145h.166c.627,0,1.348.049,1.348.865,0,.756-.639.863-1.252.863h-.262Z",
    transform: "translate(-769.781 -922.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M837.565,924.41v1.49h2.612v1.963h-2.612V929.4h2.754v1.963h-5.071v-8.917h5.071v1.963Z",
    transform: "translate(-763.372 -922.211)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M845.307,929.4h2.778v1.963h-5.094v-8.917h2.316Z",
    transform: "translate(-757.593 -922.211)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M893.453,921.333v14.8H791.333v-14.8h102.12M894.785,920H790v17.464H894.785V920Z",
    transform: "translate(0 46.278)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d36f713bca05b2fb35202472857a5b26.svg";
export { ForwardRef as ReactComponent };